(function () {
  'use strict'

  //Global
  function Glob() {
    this.btnSearchToggle = $("#btn-search-toggle");
    this.mobileSearchToggle = $("#btn-mobile-search");
    this.searchScreenTakeover = $("#search-screen-takeover");
    this.searchScreenTakeoverCloseBtn = $("#search-screen-takeover .btn-close");
    this.headerBar = $("#shopify-section-header");
    this.dropdowns = $(".dropdown-selector");
    this.subscriptionModalButtons = $(".subscription-modal-toggle");
    this.subscriptionModalScreen = $("#weekly-subscription-wrapper");
    this.subscriptionModalScreenCloseBtn = $("#weekly-subscription-wrapper .btn-close");
    this.datePickers = $('[data-toggle="datepicker"]');
    this.sideMenuButton = $(".side-menu-icon");
    this.navDropdowns = $(".site-nav li.site-nav--has-dropdown");
    this.headerCrossLeftLine = $('#shopify-section-page-our-story .header-cross-line hr.line-left');
    this.headerCrossRightLine = $('#shopify-section-page-our-story .header-cross-line hr.line-right');
    this.ourStoryPageBorderRight = $('.our-story-page .grid__item.border-right');
    this.weddingPageBorderRight = $('.wedding-page .grid__item.border-right');
    this.privateEventsPageBorderRight = $('.private-events-page .grid__item.border-right');
  }

  Glob.prototype.initEventHandlers = function () {
    //search box
    var body = $("body");

    var screenTakeover = this.searchScreenTakeover;
    this.btnSearchToggle.click(function () {
      screenTakeover.addClass("active");
      screenTakeover.find('input').focus();
      screenTakeover.find('input').val("");
      body.addClass("overflow-hidden-fixed");
    });
    /*
    this.mobileSearchToggle.click(function () {
      screenTakeover.addClass("active");
      screenTakeover.find('input').focus();
      screenTakeover.find('input').val("");
      body.addClass("overflow-hidden-fixed");
    });
    */
    this.searchScreenTakeoverCloseBtn.click(function() {
      screenTakeover.removeClass("active");
      body.removeClass("overflow-hidden-fixed");
    });

    //Init scroll magic
    var headerBar = this.headerBar;
    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({triggerElement: "#hidden-trigger-anchor", duration: 9999, triggerHook: 0 })
      .addTo(controller)
      .on("start end", function (e) {

        if ($(window).width() >= 769) {
          if (e.scrollDirection == "FORWARD") {     
            headerBar.addClass("minified");
          }
          else {
            headerBar.removeClass("minified");
          }
        }
      });

    $(".faded").each(function(index, element) {
      new ScrollMagic.Scene({triggerElement: element, duration: 9999, triggerHook: 0.8 })
      .addTo(controller)
      .on("start", function (e) {
        e.target.triggerElement().classList.add("loaded");
      });
    });
    

    //init dropdown
    this.dropdowns.click(function () {
      $(this).find(".icon--dropdown").toggleClass("open");
      $(this).find(".dropdown").toggleClass("active");
    });

    //init datePicker
    this.datePickers.datepicker({
      startDate: new Date(),
      autoPick: true,
      autoHide: true,
      show: function () {
          $(".delivery-select").find(".icon--dropdown").addClass("open");
      },
      hide: function () {
          $(".delivery-select").find(".icon--dropdown").removeClass("open");
      }
    });

    //init subscription modal
    var subscriptionModalScreen = this.subscriptionModalScreen;
    this.subscriptionModalButtons.click(function() {
      subscriptionModalScreen.addClass("active");
    });
    this.subscriptionModalScreenCloseBtn.click(function() {
      subscriptionModalScreen.removeClass("active");
    });

    this.sideMenuButton.click(function() {
      if (body.hasClass("js-drawer-open")) {
        timber.RightDrawer.close();
        headerBar.removeClass("open-nav");
        document.body.classList.remove("overflow-hidden-fixed");
        document.documentElement.classList.remove("overflow-hidden-fixed");
      }
      else {
        headerBar.toggleClass("open-nav");
        //use jquery here will cause poor performance on mobile
        if (document.body.classList.contains("overflow-hidden-fixed")) {
          document.body.classList.remove("overflow-hidden-fixed");
          document.documentElement.classList.remove("overflow-hidden-fixed");
        }
        else {
          document.body.classList.add("overflow-hidden-fixed");
          document.documentElement.classList.add("overflow-hidden-fixed");
        }
        // $("body, html").toggleClass("overflow-hidden-fixed");
      }
    });
    this.navDropdowns.click(function() {

      var _this = $(this);
      if (_this.hasClass("open")) {
        _this.removeClass("open");
      }
      else {
        //clear all
        $(".site-nav li.site-nav--has-dropdown").removeClass("open");
        _this.addClass("open");
      }
      
    });
  }

  Glob.prototype.animateLines = function () {
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({triggerElement: ".who-we-are-line.header-cross-line hr", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".who-we-are-line .header-cross-line .line-left", "left-to-right")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".who-we-are-line .header-cross-line hr", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".who-we-are-line .header-cross-line .line-right", "right-to-left")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".our-process-line .header-cross-line hr", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".our-process-line .header-cross-line .line-left", "left-to-right")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".our-process-line .header-cross-line hr", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".our-process-line .header-cross-line .line-right", "right-to-left")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".our-team-line .header-cross-line hr", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".our-team-line .header-cross-line .line-left", "left-to-right")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".our-team-line .header-cross-line hr", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".our-team-line .header-cross-line .line-right", "right-to-left")
        .addTo(controller);

    new ScrollMagic.Scene({triggerElement: ".who-we-are-line + .grid__item", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".who-we-are-line + .grid__item", "scaleY1")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".our-process-line + .grid__item", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".our-process-line + .grid__item", "scaleY1")
        .addTo(controller);
    new ScrollMagic.Scene({triggerElement: ".our-team-line + .grid__item", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".our-team-line + .grid__item", "scaleY1")
        .addTo(controller);

    new ScrollMagic.Scene({triggerElement: ".animate-border-right-line", duration: 9999, triggerHook: 0.8 })
        .setClassToggle(".animate-border-right-line .border-right.scaleY0", "scaleY1")
        .addTo(controller);
  }

  Glob.prototype.toggleNavTextVersion = function() {
    var mainContent = $(".main-content");
    if (mainContent.find(".part-cover-with-text.light-color").length > 0 
      || mainContent.find(".section-page-cover.light-color").length > 0
      || mainContent.find(".part-policies-cover.light-color").length > 0
      || mainContent.find(".part-page-cover-image.light-color").length > 0) {
      $("#shopify-section-header").addClass("dark-version");
    }
  }

  Glob.prototype.init = function () {
    this.initEventHandlers();
    this.toggleNavTextVersion();
    this.animateLines();
    /*this.headerCrossLeftLine.addClass('left-to-right');
    this.headerCrossRightLine.addClass('right-to-left');

    this.ourStoryPageBorderRight.before().addClass('scale-to-top');
    this.weddingPageBorderRight.before().addClass('scale-to-down');
    this.privateEventsPageBorderRight.before().addClass('scale-to-down');*/
  }

  window.Glob = Glob;

}());

$(document).ready(function () {
  var glob = new Glob();
  glob.init();
});
